import React, { Component } from 'react';
import { Button, Container, Header, Icon, Segment } from 'semantic-ui-react';
import ImageCard from './ImageCard';
import PageCardList from './PageCardList';
import SingleStoryCard from './SingleStoryCard';
import StoryCardList from './StoryCardList';

class AudoryPage extends Component {
      

    renderPageComponents(list){
        let ary = [];
        for(let i=0; i<list.length; i++){
            switch(list[i].type){
                case "single":
                        ary.push(
                                <div key={'pageComponent-'+list[i].id}>
                                    <SingleStoryCard
                                        title={list[i].title}
                                        description={list[i].description}
                                        item={list[i].storyObj}
                                        />
                                </div>
                            );
                        break;
                case "list1":
                case "list2":
                case "list3":
                    ary.push(
                        <div key={'pageComponent-'+list[i].id}>
                            <StoryCardList
                                title={list[i].title}
                                list={list[i].storiesObj}
                                linkToPage={list[i].linkToPage} />
                                </div>
                            );
                        break;
                        
                    case "pageList":
                        ary.push(
                            <div key={'pageComponent-'+list[i].id}>
                                <PageCardList
                                    title={list[i].title}
                                    list={list[i].pageList} />
                                    </div>
                                );
                            break;
                                    
                    case "card":
                        ary.push(
                            <div key={'pageComponent-'+list[i].id}>
                                <ImageCard
                                    item={list[i]}
                                    />
                            </div>
                                );
                            break;
                                    
            }
        }
        return ary;
    }

    render() {
        if(!this.props.page) return null;
        return (
            <div style={{maxWidth: "1920px", margin: 'auto', padding: '2em'}}>
                {this.props.page.listObjs && this.renderPageComponents(this.props.page.listObjs)}
                {!this.props.page.listObjs && (
                    <Container
                    
                    textAlign='center'
                    style={{ padding: '0em 0em' }}
                  >
                  <Container text style={{padding: '5em 0em'}}>
                    <Header
                        as='h1'
                        content='Seite existiert nicht'
                        
                        style={{
                        fontSize: '2em',
                        fontWeight: 'normal',
                        marginBottom: 0,
                        }}
                    />
                    <Header
                        as='h2'
                        
                        style={{
                        fontSize: '1.5em',
                        fontWeight: 'normal',
                        margin: '1em'
                        }}
                    >
                        Die Hörbuchseite, die du aufrufen möchtest, existiert leider nicht...
                    </Header>
                    <Button size='huge' color='green' href='/'>
                        Zu den Hörbüchern
                        <Icon name='right arrow' />
                    </Button>
                    </Container>
                </Container>
                )}
            </div>
        );
    }
}

export default AudoryPage;



// WEBPACK FOOTER //
// ./src/components/PageComponents/AudoryPage.js